
import { Component, Prop, Vue } from 'vue-property-decorator';
import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import { schedule101DataInfoType } from '@/types/Application/FamilyLawMatter/Pdf';
import { animalRelationshipToOtherPartyDataInfoType, disagreePropertyDivisionDataInfoType, propertyDivisionOrderDataInfoType, replyNewPropertyDivisionDataInfoType } from '@/types/Application/ReplyFamilyLawMatter/CompanionAnimal';

@Component({
    components:{
        UnderlineForm,
        CheckBox
    }
})

export default class Schedule101 extends Vue {

    @Prop({required:true})
    result!: any; 
   
    dataReady = false;
    replyNewCompInfo = {} as schedule101DataInfoType;
   
    mounted(){
        this.dataReady = false;      
        this.extractInfo();       
        this.dataReady = true;        
    }    

    public extractInfo(){ 
        this.replyNewCompInfo = this.getReplyNewCompanionAnimalInfo(); 
    }

    public getReplyNewCompanionAnimalInfo(){
       
        let replyNewCompanionInfo = {} as schedule101DataInfoType;

        replyNewCompanionInfo = {
            newOrderDetails: '',
            disagreeReason: '',
            spouse: false,
            relationshipDetails: '' 
        }

        if (this.result.disagreePropertyDivisionSurvey){
            const disagreePropertyDivisionData: disagreePropertyDivisionDataInfoType = this.result.disagreePropertyDivisionSurvey;
            replyNewCompanionInfo.disagreeReason = disagreePropertyDivisionData.disagreeCompanionAnimalOrder?disagreePropertyDivisionData.disagreeCompanionAnimalOrder:'';           
        }

        if (this.result.animalRelationshipToOtherPartySurvey){
            const animalRelationshipToOtherPartyData: animalRelationshipToOtherPartyDataInfoType = this.result.animalRelationshipToOtherPartySurvey;
            replyNewCompanionInfo.spouse = animalRelationshipToOtherPartyData.otherPartyIsSpouse == 'y';
            if (!replyNewCompanionInfo.spouse){
                replyNewCompanionInfo.relationshipDetails = animalRelationshipToOtherPartyData.otherPartyRelationshipDesc?animalRelationshipToOtherPartyData.otherPartyRelationshipDesc:'';
            }
        }

        if (this.result.propertyDivisionOrderSurvey){
            const propertyDivisionOrderData: propertyDivisionOrderDataInfoType = this.result.propertyDivisionOrderSurvey;
            replyNewCompanionInfo.newOrderDetails = propertyDivisionOrderData.propertyDivisionCourtOrderBelief?propertyDivisionOrderData.propertyDivisionCourtOrderBelief:'';           
        }
        
       return replyNewCompanionInfo;
   } 

}
